import { render, staticRenderFns } from "./AppScoresSoccerStatistics.vue?vue&type=template&id=0c8b7e89&"
import script from "./AppScoresSoccerStatistics.vue?vue&type=script&lang=js&"
export * from "./AppScoresSoccerStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports